export const envName = process.env.REACT_APP_ENV;

/**
 * 根据给定后缀在 .env 中获得相应的值，查找顺序是先找带 envName 的 key，如果没有则找不带 envName 的 key.
 *
 * 例如 API_ROOT:
 * 将会先查找 REACT_APP_QA_API_ROOT
 * 之后查找 REACT_APP_API_ROOT
 */
export function getByEnv(keySuffix) {
    return (
        process.env[`REACT_APP_${envName}_${keySuffix}`] ?? process.env[`REACT_APP_${keySuffix}`]
    );
}

/**
 * 当前是否生产环境。
 *
 * @type {boolean}
 */
export const isProd = process.env.NODE_ENV === 'production';

/**
 * 部分功能只在开发环境下出现，所以使用此属性来控制。
 *
 * @type {boolean}
 */
export const showAtDev = !isProd;

/**
 * 应用的标题
 *
 * @type {string}
 */
export const APP_TITLE = process.env.REACT_APP_TITLE;

/**
 * 后台 api 根路径
 *
 * @type {string}
 */
export const API_ROOT = getByEnv('API_ROOT');
export const URL_ROOT = getByEnv('URL_ROOT');

/** 知情同意（wxSend）企微 corpId / 应用 appId / agentId */
export const CONSENT_CORP_ID = getByEnv('CONSENT_CORP_ID');
export const CONSENT_APP_ID = getByEnv('CONSENT_APP_ID');
export const CONSENT_AGENT_ID = getByEnv('CONSENT_AGENT_ID');

/** 签到二维码（wxQrCode）OAuth appId / open 接口 appId / agentId */
export const QR_APP_ID = getByEnv('QR_APP_ID');
export const QR_OPEN_APP_ID = getByEnv('QR_OPEN_APP_ID');
export const QR_AGENT_ID = getByEnv('QR_AGENT_ID');

/**
 * 具体实现可参见 {@link https://github.com/facebook/create-react-app/blob/master/packages/react-dev-utils/getPublicUrlOrPath.js|getPublicUrlOrPath}
 * 和 {@link https://github.com/facebook/create-react-app/blob/master/packages/react-scripts/config/env.js env.js} .
 *
 * 定义方式如下：
 * 1. package.json 中配置 homepage，例如 http://example.com/abc, 则取值为 /abc/
 * 2. 启动时配置 process.env.PUBLIC_URL， 例如 cross-env PUBLIC_URL=/abc/
 * 3. 上述均未配置，则默认使用 /
 *
 * @type {string}
 */
export const PUBLIC_URL = process.env.PUBLIC_URL;

/**
 * 带水印的图文中显示的水印字段，默认为 SysUser#name
 * @type {string}
 */
export const ARTICLE_MASK_FIELD = process.env.REACT_APP_ARTICLE_MASK_FIELD ?? 'name';

/**
 * 登录方式
 *
 * @type {string|string} 'default' 表示默认的用户名密码登录，'azure' 表示使用 Azure 的 sso 登录
 */
export const AUTH_TYPE = getByEnv('AUTH_TYPE') ?? 'default';

/**
 * 应用布局方式，支持默认布局 default、流式布局 flow
 *
 * @type {string|string}
 */
export const APP_LAYOUT = process.env.REACT_APP_LAYOUT ?? 'default';

export const REACT_APP_CON = process.env.REACT_APP_CON;

export function isDefaultAppLayout() {
    return APP_LAYOUT === 'default';
}

export function isDefaultCon() {
    console.log('--process.env.', REACT_APP_CON);
    return REACT_APP_CON === 'default';
}
